import React, { useEffect, useState } from "react";
import VideoCard from "./VideoCard";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { course } from "../../demodata/Course.jsx";
import { fetchCourses } from "../../api/Evaluation";
import Loading from "../../utils/Loading.jsx";

const Video = () => {
  const [Courses, setCourses] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(true);
  const [active, setActive] = useState("thought");

  const loadCourses = async () => {
    try {
      const data = await fetchCourses();
      setCourses(data);
    } catch (error) {
      console.error("❌ Error fetching courses:", error);
    } finally {
      setLoadingCourses(false);
    }
  };

  useEffect(() => {
    loadCourses();
  }, []);

  return (
    <div className="w-full bg-[#00294B] flex justify-center items-center sm:py-[7rem] py-[4rem]">
      <div className="container flex flex-col items-center justify-center gap-4 px-4 sm:px-0">
        <h1 className="sm:text-4xl text-3xl font-bold text-white text-center">
          শিক্ষার্থী, শিক্ষক ও শিক্ষা প্রতিষ্ঠানের জন্য অনলাইন কোর্স
        </h1>
        <p className="text-white text-center text-xl">
          অনলাইন কোর্স এ আজই জয়েন করুন এবং হয়ে উঠুন একজন দেশ সেরা শিক্ষক
        </p>
        {loadingCourses ? (
          <Loading />
        ) : (
          <div className="sm:my-[5rem] mt-[2rem] sm:mb-[2rem] mb-[1rem] w-full">
            <Swiper
              className="mySwiper"
              modules={[Autoplay]}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              speed={800}
              loop
              spaceBetween={30}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                640: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 3,
                },
                1280: {
                  slidesPerView: 4,
                },
              }}
            >
              {Courses.map((item, idx) => (
                <SwiperSlide key={idx}>
                  <VideoCard item={item} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}

        <div className="w-full flex justify-center items-center">
          <Link
            to="/qs-academy/course/"
            className="py-2 px-10 bg-[#22BEFF] cursor-pointer rounded-md font-medium hover:text-white"
          >
            সকল কোর্স
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Video;
